module.exports = __webpack_public_path__ + "img/img-main-bg03.a3ff5155.png";